export const black = '#212121'
export const white = '#FFFFFF'
export const grayOnBlack = '#616161'
export const grayOnWhite = '#E0E0E0'
export const almostWhiteOnGray = '#FAFAFA'
